define(function (require) {
    "use strict";

    var LE = require("app");
    var _ = require("underscore");
    var ApiResources = require("assets/data/apiResources.json");
    var Config = require("manager-assets/config/config.json");

    var RevisionedModel = require("models/RevisionedModel");
    var ScheduleUtilities = require("utils/ScheduleUtilities");
    var SpecialOccasionEventsCollection = require("collections/entities/scheduling/SpecialOccasionEventsCollection");

    var KEYS = {
        NAME: "name",
        DESCRIPTION: "description",
        IS_DEFAULT: "isDefault",
        EVENTS: "events"
    };

    var SpecialOccasionModel = RevisionedModel.extend({
        KEYS: KEYS,
        name: "SpecialOccasionModel",
        resource: ApiResources.AccountConfig.SpecialOccasions,
        defaults: {
            id: null,
            name: "",
            description: "",
            isDefault: false,
            events: []
        },

        validation: {
            name: [
                {
                    required: true,
                    minLength: 1,
                    msg: "LEFramework.entities.specialOccasion.errors.name.required"
                },
                {
                    maxLength: Config.validators.specialOccasions.event.maxNameLength,
                    msg: "LEFramework.entities.specialOccasion.errors.name.maxLength"
                }
            ],
            description: [
                {
                    required: false,
                    minLength: 0,
                    maxLength: Config.validators.specialOccasions.maxDescriptionLength,
                    msg: "LEFramework.entities.specialOccasion.errors.description.maxLength"
                }
            ],
            duplicate: [
                {
                    fn: function() {
                        // validate hierarchy the collection
                        var eventsCollectionErrors = this.eventsCollection.validate();
                        if (!_.isEmpty(eventsCollectionErrors)) {
                            return "LEFramework.entities.specialOccasion.errors.generalError.internalError";
                        }
                    }
                }
            ]
        },

        initialize: function(attrs, options) {
            // eventsCollection can be initialized if the "parse" was triggered before the initialize.
            // this can be happened when the model is part of the collection, and we are doing collection fetch.
            if (!this.eventsCollection) {
                this.eventsCollection = new SpecialOccasionEventsCollection();
                // if we got attrs in the initialize we want to init the eventsCollection with the events from the attributes
                // we get these attrs when we clone the model
                if (attrs && attrs.events) {
                    this._parseSpecialOccasionEvents(attrs.events);
                    this.parsedTimezone = ScheduleUtilities.getTimezoneFromEvents(attrs.events);
                }
                else {
                    this.parsedTimezone = ScheduleUtilities.getTimezoneFromEvents([]); // when we don't have events yet, getTimezoneFromEvents will return the default timezone
                }
            }

            RevisionedModel.prototype.initialize.call(this, attrs, options);
        },

        parse: function(response, options) {
            response = this._getModelFromResponse(response);
            var eventsArr = response.events;
            this.parsedTimezone = ScheduleUtilities.getTimezoneFromEvents(eventsArr);
            if (this.eventsCollection) {
                this.eventsCollection.reset();
            }
            else {
                this.eventsCollection = new SpecialOccasionEventsCollection();
            }
            this._parseSpecialOccasionEvents(eventsArr);
            return RevisionedModel.prototype.parse.call(this, response, options);
        },

        getName: function() {
            return this.get(KEYS.NAME);
        },

        setName: function(name) {
            this.set(KEYS.NAME, name);
        },

        getEventsCollection: function() {
            return this.eventsCollection;
        },

        getTimezone: function() {
            return this.parsedTimezone;
        },

        setTimezone: function(timezone) {
            this.parsedTimezone = timezone;
        },

        getDescription: function() {
            return this.get(KEYS.DESCRIPTION);
        },

        setDescription: function(description) {
            this.set(KEYS.DESCRIPTION, description);
        },

        setIsDefault: function(isDefault) {
            this.set(KEYS.IS_DEFAULT, isDefault);
        },


        addNewEvent: function() {
            var eventModel = this.eventsCollection.model;
            this.eventsCollection.add(new eventModel(), {at: 0});
        },

        clearAllEvents: function() {
            this.eventsCollection.reset();
        },

        removeEvent: function(eventModel) {
            this.eventsCollection.remove(eventModel);
        },

        toJSON: function (options) {
            var json = RevisionedModel.prototype.toJSON.apply(this, [].slice.apply(arguments));
            json.events = ScheduleUtilities.createSpecialOccasionEventsApiFormat(this.getEventsCollection(), this.getTimezone());
            return json;
        },

        isDeletable: function() {
            return true;
        },

        isEditable: function() {
            return true;
        },

        isViewable: function() {
            return true;
        },

        isDuplicatable: function() {
            return true;
        },

        canSetUserDefault: function() {
            return false;
        },
        isSystemDefault: function() {
            return this.get(KEYS.IS_DEFAULT);
        },
        isUserDefault: function (){
            return this.isSystemDefault();
        },

        /**
         * check: name
         * @returns {boolean|*}
         */
        validateMandatoryFilled: function () {
            return  this._validateMandatoryFilled();
        },

        _getModelFromResponse: function (response) {
            if(_.isArray(response)) {
                response = _.find(response, {id:this.id});
            }
            return response;
        },

        _validateMandatoryFilled: function(){
            var hasName =  this.getName();

            //The trim is used to disable the save button in case that there are only spaces character in the input field
            hasName = hasName.trim();

            return hasName;
        },

        _parseSpecialOccasionEvents: function(eventsArr) {
            _.each(eventsArr, _.bind(function(eventObj) { //go over the events, and parse each one

                var parsedEventObj = ScheduleUtilities.getParsedEvent(eventObj);

                //Check if we already have event with same id. If so, we need to update the existing event. otherwise, we can just push the new event.
                var currentEventId = ScheduleUtilities.getSpecialOccasionEventId(parsedEventObj.name, parsedEventObj.startDate, parsedEventObj.endDate);
                parsedEventObj.id = currentEventId;
                var existingEventModel = this.eventsCollection.get(currentEventId);
                if (existingEventModel) {
                    this._updateExistingSpecialOccasionEventModel(existingEventModel, parsedEventObj);
                }
                else {
                    this._addEventModel(parsedEventObj);
                }
            }, this));
        },

        _addEventModel: function (attr) {
            var Model = this.eventsCollection.model;
            this.eventsCollection.add(new Model(attr));
        },

        _updateExistingSpecialOccasionEventModel: function(existingEventModel, newEventObj) {
            if (existingEventModel.getType() === ScheduleUtilities.EVENT_TYPES.CUSTOM && newEventObj.type === ScheduleUtilities.EVENT_TYPES.CUSTOM) {
                //If both events are custom, we just join their shifts
                existingEventModel.addShift(newEventObj.shifts[0]);
            }
            else {
                //Any other way, Inactive or All hours, we want shifts to be an empty array
                if (newEventObj.type === ScheduleUtilities.EVENT_TYPES.INACTIVE || existingEventModel.getType() === ScheduleUtilities.EVENT_TYPES.CUSTOM) {
                    //We override only if the existing event is custom or the new event is inactive
                    existingEventModel.setType(newEventObj.type);
                }
            }
        }
    });

    SpecialOccasionModel.KEYS = KEYS;

    return SpecialOccasionModel;
});
